"use strict";
import { useMemo } from "react";
import { getUniconColors, passesContrast, useExtractedColors, useIsDarkMode, useSporeColors } from "ui/src";
import { useAvatar } from "features/address/avatar";
export function useAddressColorProps(address) {
  const colors = useSporeColors();
  const isDarkMode = useIsDarkMode();
  const { color: uniconColor } = getUniconColors(address, isDarkMode);
  const { avatar, loading: avatarLoading } = useAvatar(address);
  const { colors: avatarColors } = useExtractedColors(avatar);
  const hasAvatar = !!avatar && !avatarLoading;
  const smartColor = useMemo(() => {
    const contrastThreshold = 3;
    const backgroundColor = colors.surface2.val;
    if (hasAvatar && avatarColors && avatarColors.primary) {
      if (passesContrast(avatarColors.primary, backgroundColor, contrastThreshold)) {
        return avatarColors.primary;
      }
      if (passesContrast(avatarColors.base, backgroundColor, contrastThreshold)) {
        return avatarColors.base;
      }
      if (passesContrast(avatarColors.detail, backgroundColor, contrastThreshold)) {
        return avatarColors.detail;
      }
      return colors.neutral1.val;
    }
    return uniconColor;
  }, [avatarColors, hasAvatar, uniconColor, colors.surface2.val, colors.neutral1.val]);
  return smartColor;
}
